<template>
    <div class="plateTitle">
        <div>{{ title }}</div>
    </div>
</template>

<script>
export default {
    name: 'plateTitle',

    props: { title: String },
}
</script>

<style lang="less" scoped>
.plateTitle {
    width: 28.54vw;
    height: 38.5px;
    background: linear-gradient(90deg, #073590 0%, rgba(7,53,144,0.00) 100%);
    > div {
        left: 8px;
        top: 8px;
        height: 22px;
        font-size: 16px;
        font-weight: normal;
        color: #01FFFF;
        text-align: left;
    }
}

</style>
